"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roccapiemonte": {
    "6c0f54eb": [{
      "hkey": "d26453e3",
      "slug": "casali-san-potito",
      "name": "Casali-San Potito",
      "primary": true,
      "skipSearch": false
    }],
    "casali": [{
      "hkey": "d26453e3",
      "slug": "casali-san-potito",
      "name": "Casali-San Potito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1369168a": [{
      "hkey": "d24bfafb",
      "slug": "roccapiemonte",
      "name": "Roccapiemonte",
      "primary": true,
      "skipSearch": false
    }],
    "materdomini": [{
      "hkey": "d24bfafb",
      "slug": "roccapiemonte",
      "name": "Roccapiemonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0efd6456": [{
      "hkey": "d26453e3",
      "slug": "casali-san-potito",
      "name": "Casali-San Potito",
      "primary": true,
      "skipSearch": false
    }],
    "san-potito": [{
      "hkey": "d26453e3",
      "slug": "casali-san-potito",
      "name": "Casali-San Potito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roccapiemonte"
    }]
  }
};
exports["default"] = _default;